const getStyles = () => {
  return {
    section: {
      padding: '80px 0',
      background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    container: {
      maxWidth: '900px',
      margin: '0 auto',
      padding: '0 16px'
    },
    formWrapper: {
      backgroundColor: '#ffffff',
      borderRadius: '24px',
      padding: '40px',
      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
      border: '1px solid rgba(255, 255, 255, 0.5)',
      backdropFilter: 'blur(10px)'
    },
    header: {
      textAlign: 'center',
      marginBottom: '40px'
    },
    title: {
      fontSize: '3rem',
      fontWeight: '700',
      background: 'linear-gradient(135deg, #2563eb 0%, #1e40af 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      marginBottom: '16px'
    },
    subtitle: {
      fontSize: '1.1rem',
      color: '#64748b',
      maxWidth: '600px',
      margin: '0 auto'
    },
    sectionTitle: {
      fontSize: '1.5rem',
      fontWeight: '700',
      color: '#1e293b',
      marginBottom: '24px',
      marginTop: '32px',
      borderBottom: '2px solid #e2e8f0',
      paddingBottom: '8px',
      display: 'inline-block'
    },
    inputGroup: {
      marginBottom: '8px'
    },
    label: {
      display: 'block',
      fontSize: '0.95rem',
      fontWeight: '600',
      color: '#475569',
      marginBottom: '8px'
    },
    helperText: {
      fontSize: '0.85rem',
      color: '#94a3b8',
      marginBottom: '8px',
      fontStyle: 'italic'
    },
    textField: {
      width: '100%',
      '& .MuiOutlinedInput-root': {
        borderRadius: '12px',
        backgroundColor: '#f8fafc',
        transition: 'all 0.3s ease',
        '& fieldset': {
          borderColor: '#e2e8f0'
        },
        '&:hover fieldset': {
          borderColor: '#cbd5e1'
        },
        '&.Mui-focused fieldset': {
          borderColor: '#2563eb',
          borderWidth: '2px'
        },
        '&:hover': {
          backgroundColor: '#ffffff',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)'
        }
      }
    },
    checkboxLabel: {
      '& .MuiFormControlLabel-label': {
        fontSize: '0.95rem',
        color: '#475569'
      }
    },
    submitButton: {
      marginTop: '40px',
      padding: '16px 48px',
      fontSize: '1.1rem',
      fontWeight: '700',
      borderRadius: '50px',
      background: 'linear-gradient(135deg, #2563eb 0%, #1e40af 100%)',
      color: '#ffffff',
      textTransform: 'none',
      boxShadow: '0 10px 20px rgba(37, 99, 235, 0.2)',
      transition: 'all 0.3s ease',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 15px 30px rgba(37, 99, 235, 0.3)'
      }
    }
  };
};

export default getStyles;
